import { getAssetUrl } from '../../helpers'
import './styles.css'

type Props = {
  label: string
  value: string | undefined
  imageName: string
}

export default function InfoLine({ label, value, imageName }: Props) {
  if (!value) {
    return null
  }

  return (
    <div className="info-line">
      <img alt={`${imageName} icon`} src={getAssetUrl(`${imageName}.png`)} />
      <div>
        <label>{label}</label>
        <div className="value">{value}</div>
      </div>
    </div>
  )
}
